/** @jsxImportSource @emotion/react */

import { replacePhoneNumber } from "helpers/replace-phone-number";
import { useSelector } from "react-redux";
import { selectProfile } from "store/user";

import { MPhoneNumberCardStyle } from "./index.style";

const MPhoneNumberCard = () => {
  const profile = useSelector(selectProfile);

  return (
    <div css={MPhoneNumberCardStyle.self}>
      <div css={MPhoneNumberCardStyle.cardBody}>
        <div css={MPhoneNumberCardStyle.alert}>
          {replacePhoneNumber(profile?.mobile || "")}
        </div>
      </div>
    </div>
  );
};

export default MPhoneNumberCard;
